type CoinBadgeProps = {
  value: number | string;
  /** If omitted, component reads size from CSS var --s */
  size?: number;
  className?: string;
  title?: string;
};

export const CoinBadge: React.FC<CoinBadgeProps> = ({ value, size, className = '', title }) => {
  const borderW = size ? Math.max(2, Math.round(size * 0.07)) : undefined;
  const fontSize = size ? Math.round(size * 0.52) : undefined;

  return (
    <div className={className ?? ''}>
      <div
        className={`relative isolate inline-flex select-none items-center justify-center rounded-full`}
        title={title ?? String(value)}
        aria-label={`badge ${value}`}
        style={{
          width: size ? size : 'var(--s)',
          height: size ? size : 'var(--s)',
          borderStyle: 'solid',
          borderColor: '#C0820B',
          borderWidth: size ? borderW : 'calc(var(--s) * 0.07)',
          background: 'linear-gradient(180deg, #FFC000 0%, #FF8B00 100%)',
          boxShadow: 'inset 0 3px 0 0 #FFEF21, 0 4px 12px rgba(0,0,0,.25)',
        }}
      >
        <span
          aria-hidden
          className="pointer-events-none absolute inset-0 rounded-full"
          style={{
            background:
              'radial-gradient(120% 90% at 35% 0%, rgba(255,255,255,.55) 0%, rgba(255,255,255,0) 60%)',
          }}
        />
        <span
          aria-hidden
          className="pointer-events-none absolute inset-[10%] rounded-full opacity-85"
          style={{
            background: 'linear-gradient(180deg, #FFBD11 0%, #FF8A00 100%)',
          }}
        />
        <span
          className="relative z-10 font-black leading-none"
          style={{ fontSize: size ? fontSize : 'calc(var(--s) * 0.52)', color: '#5b3b00' }}
        >
          {value}
        </span>
      </div>
    </div>
  );
};
